import React from 'react';
const GlucoseLine = ({ glucoseLine }) => (
  <g>
    <path d={glucoseLine} fill="none" stroke="#f46157"></path>
  </g>
);
export default GlucoseLine;
